module.exports = __webpack_public_path__ + "static/media/referralImg.015c3b42.svg";